<!--
 * @Description: 
 * @Autor: jyf
 * @Date: 2021-06-29 14:36:24
 * @LastEditors: qiuwenjing qiuwenjing@vip56.cn
 * @LastEditTime: 2024-06-27 09:50:33
-->

<template>
<div class="n_box">
	
	<van-popover
	v-model="showPopover"
	trigger="click"
	:placement="placement"
	>
	<div class="nr">
		<div class="tit">批量设置数量</div>
		<input class="pi_input pi_number" v-model="value" type="text" :placeholder="placeholder" :style="styleStr"
			:maxlength="maxLength"
			oninput="value = value.replace(/[^0-9]/g, '');"
		>
		<div class="foot_btns">
            <div class="fb_r">
                <div class="btn delete_btn" @click="closeFn()">取消</div>
                <div class="btn" @click="collaspeFun()">确定</div>
            </div>
		</div>
		<!-- <div class="key-board" >
		
			  <div class="keys">
				  <div class="key_l">
					  <div class="key button" v-for="num in config.loop" :key="num.key" @click="number(num.number)">{{num.number}}</div>
						<div class="key button" @click="clearFun" style="font-size: 1.76vw;color: #FF4848;">清空</div>
						<div class="key button" @click="number(0)">0</div>
						<div class="key button" @click="del">
						  <img src="@/assets/padImg/del2.png" style="width: 3.13vw;height: 2.29vw;" alt="">
					  </div>
				  </div>
				  <div class="key_r">
					
					  <div class="key button key2" @click="collaspeFun" >
						  确定
					  </div>
	
				  </div>
			  </div>
		</div>  -->
	</div>

	<template #reference>
			
			<span  :style="btnStr">{{batchname}}</span>
		</template>
		</van-popover>
</div>
</template>


<script>
export default {
  props: {
		isNeedDot: {
			type: Boolean,
			default: true
		},
		maxLength: {
			type: Number,
			default: 10
		},
		defaultVal: {
			type: String,
			default: null
		},
		placement: {
			type: String,
			default: 'bottom'
		},
		width: {
			type: String,
			default: '24.89vw'
		},
		height: {
			type: String,
			default: '3.37vw'
		},
		styleStr: {
			type: String,
			default: 'width:100%;height:4.1vw;'
		},
		btnStr: {
			type: String,
			default: 'color: #CEB57D;font-size: 0.88vw;'
		},
		placeholder: {
			type: String,
			default: '请输入'
		},
		batchname: {
			type: String,
			default: '批量设置'
		},
		
	},
  data() {
    return {
	  value:null,
	  showPopover:false,
      config :{
				loop : [
					{
						number : 1,
						key : 'number-1',
					},
					{
						number : 2,
						key : 'number-2',
					},
					{
						number : 3,
						key : 'number-3',
					},
					{
						number : 4,
						key : 'number-4',
					},
					{
						number : 5,
						key : 'number-5',
					},
					{
						number : 6,
						key : 'number-6',
					},
					{
						number : 7,
						key : 'number-7',
					},
					{
						number : 8,
						key : 'number-8',
					},
					{
						number : 9,
						key : 'number-9',
					},
				]
			},

    };
  },
  watch: {
		showPopover: function(value, oldValue) {
			if(value==false){
				this.value = null;
			}
		}
		
	},

  methods: {
    close(){
		this.showKeyBoard = false;
		this.$emit("close");
	},
	del() {
		if(!this.value) return;
		let index = this.value.length;
        this.value = this.value.toString().slice(0,index-1);
		
	},
	number(number) {
		// this.$emit("number", number);
		let val = this.value;
		let dotIndex = this.value?this.value.toString().indexOf('.'):-1;
		if(number=='.'&&dotIndex>-1||this.value&&this.value.toString().length==this.maxLength) return;
		this.value = this.value?this.value.toString() + number.toString():number.toString();
		if(dotIndex>-1){
			if(val.toString().slice(dotIndex+1).length>1){
				this.value = this.value.slice(0,dotIndex+3)
			}
		}else{
			this.value = this.value.slice(0,this.maxLength)
		}

	},
	collaspeFun(){
		this.showPopover = false;
		this.finishFun();
	},
	closeFn(){
		this.showPopover = false;
	},
	finishFun(){
	this.$emit('finishFun',this.value);
	},
	clearFun(){
		this.value = null;

}

  },
  onLoad() {
  },
  onShow() {},
  mounted() {
    this.value = this.defaultVal;

  }

};
</script>

<style lang="scss" scoped>
.nr{
	box-sizing: border-box;
	padding: 2.05vw 1.54vw 1.98vw 2.12vw;
	.tit{
		font-size: 1.46vw;
		font-weight: bold;
		letter-spacing: 0px;
		color: #1A1A1A;
		margin-bottom: 1.54vw;
	}
}
.pi_input{
	width: 32.94vw;
	height: 4.1vw;
	border: 0.11vw solid #AAAAAA;
	border-radius: 0.29vw;
	font-size: 1.46vw;
	font-weight: bold;
	letter-spacing: 0px;
	color: #767676;
	padding-left: 2.2vw;
	margin-bottom: 1.39vw;
}
.foot_btns {
        width: 100%;
        height: 80px;
        background-color: #fff;
        display: flex;
        align-items: center;
        justify-content: space-between;
        flex-direction: row-reverse;
        box-sizing: border-box;
        padding-left: 4.83vw;
        padding-right: 2.93vw;
        box-sizing: border-box;

        .fb_r {
            display: flex;
            align-items: center;

            .btn {
                width: 8.78vw;
                height: 3.39vw;
                border-radius: 0.29vw;
                background: #CEB57D;
                text-align: center;
                line-height: 3.39vw;
                font-size: 1.17vw;
                font-weight: normal;
                letter-spacing: 0px;
                color: #FFFFFF;
                margin-right: 1.46vw;

                &:last-child {
                    margin-right: 0;
                }

                &.delete_btn {
                    border: 1PX solid #FA5151;
                    background: transparent;
                    color: #FA5151;
                }
            }
        }
    }
.key-board {
	width: 32.94vw;
	box-sizing: border-box;

	.title {
		display: flex;
		justify-content: center;
		align-items: center;
		height: 8vw;
		background: #eeeeee;
	}
	.keys {
		display: flex;
		width: 100%;
		.key_l{
			display: flex;
			flex-wrap: wrap;
			width: max-content;
			.key{
				margin-right: 0.88vw;
				margin-bottom: 0.8vw;
				&:nth-child(2n){
					margin-right: 0.97vw;
				}
				&:nth-child(3n){
					margin-right: 0;
				}
			}
		}
		.key_r{
			width: 7.76vw;
			.key{
				margin-bottom: 0.73vw;
			}
			.key2{
				height: 24.82vw;
				background: linear-gradient(200deg, #CEB57D 4%, #BFA05B 85%), #FFFFFF;
				box-shadow: 0px 0.29vw 0px 0px rgba(0, 0, 0, 0.3);
				font-size: 1.76vw;
				color: #ffffff;
			}
		}
		.key {
			width: 7.38vw;
			height: 5.6vw;
			display: flex;
			justify-content: center;
			align-items: center;
			box-sizing: border-box;
			color: #1A1A1A;
			background: #ffffff;
			font-size: 2.64vw;
			font-weight: bold;
			line-height: 5.6vw;
			text-align: center;
			letter-spacing: 0px;
			color: #1A1A1A;
			border: 1PX solid #D8DCE5;
			box-shadow: 0px 0.29vw 0px 0px rgba(0, 0, 0, 0.3);
			border-radius: 0.29vw;
		}
		
	}
	
}

</style>


// WEBPACK FOOTER //
// src/components/pad/batchSettings.vue